import { useQuery } from "react-query";

import { autoChecklistService } from "services";

const useTINCheckResultQuery = ({
	id,
	enabled = true,
}: {
	id: string;
	enabled?: boolean;
}) =>
	useQuery(["getTINCheck", id], () => autoChecklistService.getTINCheck(id), {
		retry: 0,
		cacheTime: 0,
		enabled: enabled && !!id,
	});

export default useTINCheckResultQuery;
